import { FC } from 'react';
import { CheckCircle2 } from 'lucide-react';
import { useTranslation } from '@hooks/useTranslation';

export interface ResendConfirmationProps {
  cooldownSeconds: number;
  onGoToSignIn: () => void;
}

/** Sprint 47, story-232. Same wording whatever email was typed (no account enumeration). */
export const ResendConfirmation: FC<ResendConfirmationProps> = ({
  cooldownSeconds,
  onGoToSignIn,
}) => {
  const tSetup = useTranslation('setup');
  return (
    <div className="flex flex-col gap-4" data-testid="setup-resend-sent">
      <div className="flex items-start gap-2">
        <CheckCircle2
          aria-hidden="true"
          className="mt-1 h-5 w-5 shrink-0 text-green-600"
        />
        <h1
          tabIndex={-1}
          className="text-xl font-bold text-gray-900 dark:text-white">
          {tSetup.resendSentTitle}
        </h1>
      </div>
      <p className="text-gray-600 dark:text-gray-300">{tSetup.resendSentBody}</p>
      {cooldownSeconds > 0 && (
        <p className="text-sm text-gray-500 dark:text-gray-400" aria-live="polite">
          {tSetup.resendCooldown.replace('{seconds}', String(cooldownSeconds))}
        </p>
      )}
      <button
        type="button"
        onClick={onGoToSignIn}
        className="text-sm text-indigo-600 hover:underline dark:text-indigo-300">
        {tSetup.goToSignIn}
      </button>
    </div>
  );
};

export default ResendConfirmation;
